import { LABEL_MISSING } from '../../enums';
import { getLabel } from '../../Language/labels';

export const getErrorMessage = (api_errors) => {
  let result = [];
  //const result = getLabel(Object.keys(api_errors)[0]);

  for (const key in api_errors) {
    if (Object.hasOwnProperty.call(api_errors, key)) {
      const element = api_errors[key];
      const message = getLabel(element);
      
      if (message === LABEL_MISSING) {
        result.push(element);
      }else{
        result.push(message);
      }
    }
  }

  return result;
}